import React, { useState, useEffect } from "react";
import classes from "./ScrollProgress.module.css";

const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(scrollPercent);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={classes.ScrollProgress}>
      <div
        className={classes.Bar}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ScrollProgress;
